export default {
  description: '当前页面启用的语言，消费者端切换语言时才能选到；消费者端页面优先展示默认语言',
  language: '语言',
  defaultLanguage: '默认语言',
  enabled: '是否启用',
  traditionalChinese: '繁體中文',
  simplifiedChinese: '简体中文',
  english: 'English',
  japanese: 'Japanese',
  save: '保存',
  saveSuccess: '保存成功',
};
